import _objectSpread from "/Users/swong/workspace/thatonesimon.github.io/thatonesimon/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/swong/workspace/thatonesimon.github.io/thatonesimon/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/Users/swong/workspace/thatonesimon.github.io/thatonesimon/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _transitionStyles;
import classNames from 'classnames';
import * as React from 'react';
import { ENTERED, ENTERING, EXITING } from 'react-transition-group/Transition';
import transitionEndListener from './transitionEndListener';
import TransitionWrapper from './TransitionWrapper';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var transitionStyles = (_transitionStyles = {}, _defineProperty(_transitionStyles, ENTERING, 'show'), _defineProperty(_transitionStyles, ENTERED, 'show'), _transitionStyles);
var OffcanvasToggling = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    _children = _ref.children,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "children"]);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'offcanvas');
  return /*#__PURE__*/_jsx(TransitionWrapper, _objectSpread({
    ref: ref,
    addEndListener: transitionEndListener
  }, props, {
    childRef: _children.ref,
    children: function children(status, innerProps) {
      return /*#__PURE__*/React.cloneElement(_children, _objectSpread({}, innerProps, {
        className: classNames(className, _children.props.className, (status === ENTERING || status === EXITING) && "".concat(bsPrefix, "-toggling"), transitionStyles[status])
      }));
    }
  }));
});
OffcanvasToggling.defaultProps = defaultProps;
OffcanvasToggling.displayName = 'OffcanvasToggling';
export default OffcanvasToggling;